import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { API_URL } from '@constants';
import {
  Conversation,
  ConversationListElement,
  Message,
  SelectionItem,
} from '@models';

@Service()
export class MessagesService {
  http = inject(HttpClient);

  getConversations = () =>
    this.http.get<ConversationListElement[]>(`${API_URL}/conversations`);

  deleteMessage = (conversationId: number, messageId: number) =>
    this.http.delete<Message>(
      `${API_URL}/conversations/${conversationId}/messages/${messageId}`
    );

  deleteConversation = (conversationId: number) =>
    this.http.delete(`${API_URL}/conversations/${conversationId}`);

  createConversation = (data: {
    title?: Nullable<string>;
    type: Nullable<number>;
    recipients: SelectionItem[];
  }) => this.http.post<Conversation>(`${API_URL}/conversations`, data);

  updateConversation = (conversationId: number, data: Partial<Conversation>) =>
    this.http.put<Conversation>(
      `${API_URL}/conversations/${conversationId}`,
      data
    );

  leaveConversation = (conversationId: number) =>
    this.http.put<Conversation>(
      `${API_URL}/conversations/${conversationId}/leave`,
      {}
    );

  clearConversation = (conversationId: number) =>
    this.http.put<Conversation>(
      `${API_URL}/conversations/${conversationId}/clear`,
      {}
    );

  sendMessage = (
    conversationId: number,
    data: { message?: string; reference?: number }
  ) =>
    this.http.post<Message>(
      `${API_URL}/conversations/${conversationId}/messages`,
      data
    );

  getConversationUsers = () =>
    this.http.get<SelectionItem[]>(`${API_URL}/conversations/users`);

  getConversation = (
    conversationId: number,
    params?: HttpParams | Record<string, string | number>
  ) =>
    this.http.get<Conversation>(`${API_URL}/conversations/${conversationId}`, {
      params,
    });

  getMessageOrFile = (
    isFile: boolean,
    resourceId: number,
    conversationId?: number
  ) => {
    return this.http.get<Message>(
      isFile
        ? `${API_URL}/files/${resourceId}`
        : `${API_URL}/conversations/${conversationId}/messages/${resourceId}`
    );
  };
}
